import { PromoTypes } from '../../components/Layout/Promotions/types';
import { RootState } from '../store';

export const loadPlatformPromotions = (state: RootState): boolean => state.promotions?.loadPlatformPromotions;
export const activePromoType = (state: RootState): PromoTypes | null => state.promotions?.activePromoType;
